import {
  createPlugin,
  createApiFactory,
  discoveryApiRef,
} from "@backstage/core-plugin-api";
import { kajabiChatBotApiRef, KajabiChatBotApi } from "./api/KajabiChatBotApi";
import { rootRouteRef } from "./routes";

export const kajabiChatBotApiPlugin = createPlugin({
  id: "kajabi-chat-bot-api",
  apis: [
    createApiFactory({
      api: kajabiChatBotApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
      },
      factory: ({ discoveryApi }) =>
        new KajabiChatBotApi({
          discoveryApi,
        }),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});
